<template>
  <main :class="['v-view-primary',
    $store.getters.getAcademyData.persona === undefined
      ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <OrganismAccessDenied/>
  </main>
</template>

<script>
export default {
  name: 'AccessDenied',

  components: {
    OrganismAccessDenied: () => import('@/components/organisms/OrganismAccessDenied')
  }
}
</script>
